<template>
  <v-container fluid fill-height justify-center>
    <v-col>
      <!-- Sezione Password -->
      <v-row no-gutters>
        <v-form ref="formPwd" lazy-validation style="min-width: 100%">
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field class="mr-10" hide-details label="Nuova Password" v-model="cliente.passwordHash" required
                :rules="validazionePassword" :type="mostraPassword1 ? 'text' : 'password'"
                :append-icon="mostraPassword1 ? 'visibility_off' : 'visibility'"
                @click:append="mostraPassword1 = !mostraPassword1" />
            </v-col>
            <v-col cols="5">
              <v-text-field hide-details label="Ripeti Password" :value="psw" @input="$emit('update:psw', $event)"
                required :rules="validazioneConfermaPassword" :type="mostraPassword2 ? 'text' : 'password'"
                :append-icon="mostraPassword2 ? 'visibility_off' : 'visibility'"
                @click:append="mostraPassword2 = !mostraPassword2" />
            </v-col>
            <v-col cols="2">
              <v-btn class="mt-4 ml-2" @click="$emit('genera-link')">
                Genera link reset password
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-row>

      <!-- Stato Cliente -->
      <v-row no-gutters class="mt-5">
        <span class="mt-5 mr-3" hide-details style="font-size: 17px">
          Stato:
        </span>
        <v-switch v-model="cliente.enabled" color="primary" hide-details />
      </v-row>

      <!-- Registri di sintesi -->
      <v-row class="ma-0 pa-0 mt-3">
        <v-checkbox label="Abilita registro di sintesi FSC" v-model="cliente.abilitaRegistro" />
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-checkbox label="Abilita registro di sintesi PEFC" v-model="cliente.abilitaRegistroPEFC" />
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "AltriDati",

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    modifica: {
      type: Boolean,
      default: false,
    },
    psw: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    mostraPassword1: false,
    mostraPassword2: false,
  }),

  computed: {
    validazionePassword() {
      return [(v) => (v && v.length > 0) || "Campo obbligatorio"];
    },

    validazioneConfermaPassword() {
      return [(v) => (v && v.length > 0) || "Campo obbligatorio"];
    },
  },
};
</script>
